import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './Testing.css';
import SearchScreenNav from '../components/SearchScreenNav';

const Testing = () => {
  // Load the widget script when component mounts
  useEffect(() => {
    // Check if script already exists
    if (!document.getElementById('lgbt-widget-script')) {
      const script = document.createElement('script');
      script.id = 'lgbt-widget-script';
      script.src = 'https://lgbt-widget-backend.onrender.com/embed.js';
      script.setAttribute('data-api-key', 'lgbtw_03839718f22aa5d4e7edea0d7aae22a297fc78575ff88399');
      script.setAttribute('data-theme', 'ocean');
      script.async = true;
      document.body.appendChild(script);
    }
    
    // Cleanup on unmount
    return () => {
      const existingScript = document.getElementById('lgbt-widget-script');
      if (existingScript) {
        existingScript.remove();
      }
      // Also remove the widget elements created by embed.js
      const widgetButton = document.querySelector('.lgbt-widget-embedded-toggle');
      const widgetTooltip = document.querySelector('.lgbt-widget-tooltip');
      const widgetPanel = document.querySelector('.lgbt-widget-panel-container');
      if (widgetButton) widgetButton.remove();
      if (widgetTooltip) widgetTooltip.remove();
      if (widgetPanel) widgetPanel.remove();
      // Reset the loaded flag
      window.LGBTResourcesWidgetLoaded = false;
    };
  }, []);

  return (
    <div className="testing-page-container">
      <Helmet>
        <title>Widget & Map Testing | LGBT PridePath</title>
        <meta name="description" content="Test the LGBT Resources Widget and Map - find local LGBTQ+ resources in your area." />
        <link rel="canonical" href="https://www.lgbtpridepath.org/testing" />
      </Helmet>
      
      {/* Custom navigation for overlay effect */}
      <SearchScreenNav />
      
      {/* Content wrapper */}
      <div className="testing-content-wrapper">
        {/* Hero section */}
        <div className="testing-hero-section">
          <h2 className="testing-hero-subtitle">TESTING</h2>
          <h1 className="testing-hero-title">Widget & Map Testing</h1>
          <p className="testing-hero-description">
            Test our LGBT Resources Widget and interactive Map below. These tools help communities find local LGBTQ+ resources.
          </p>
        </div>
      </div>

      {/* Testing Sections */}
      <section className="testing-main-section">
        <div className="testing-main-content">
          
          {/* Widget Testing Section */}
          <div className="testing-widget-section">
            <div className="testing-section-header">
              <div className="testing-section-icon">🔍</div>
              <h2>Resource Widget</h2>
              <p>Click the floating button in the bottom-right corner to open the widget and search for local LGBT+ resources.</p>
            </div>
            <div className="testing-widget-info">
              <div className="testing-info-card">
                <h3>How It Works</h3>
                <ul>
                  <li>Click the purple button in the corner</li>
                  <li>Enter your ZIP code</li>
                  <li>Choose a category (optional)</li>
                  <li>Set your search radius</li>
                  <li>Click Search to find resources</li>
                </ul>
              </div>
              <div className="testing-info-card">
                <h3>Features</h3>
                <ul>
                  <li>Search by ZIP code and radius</li>
                  <li>Filter by resource category</li>
                  <li>Youth-safe mode available</li>
                  <li>Mobile responsive design</li>
                  <li>Collapsible search form</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="testing-divider">
            <span>OR</span>
          </div>

          {/* Map Testing Section */}
          <div className="testing-map-section">
            <div className="testing-section-header">
              <div className="testing-section-icon">🗺️</div>
              <h2>Interactive Resource Map</h2>
              <p>Explore LGBT+ resources on an interactive map. Search by location and see resources near you.</p>
            </div>
            <div className="testing-map-container">
              <iframe 
                src="https://lgbt-widget.vercel.app/map?embedded=true&apiKey=lgbtw_56027db31a08a49f125c24fca1ecda6ebb4ebcfe140f0142&theme=ocean"
                title="LGBT Resources Map"
                className="testing-map-iframe"
                allow="clipboard-write"
              />
            </div>
          </div>

          {/* Divider */}
          <div className="testing-divider">
            <span>OR</span>
          </div>

          {/* Static Widget Iframe Section */}
          <div className="testing-iframe-section">
            <div className="testing-section-header">
              <div className="testing-section-icon">📋</div>
              <h2>Static Widget Embed</h2>
              <p>The resource finder embedded directly into the page — always visible, no floating button needed.</p>
            </div>
            <div className="testing-iframe-container">
              <iframe 
                src="https://lgbt-widget.vercel.app/widget?embedded=true&apiKey=lgbtw_7b0d3db1d0ed7b1b8728fe67a3baa5f7cc3cc96cab79a4a1&theme=ocean"
                title="LGBT Resources Widget - Static Embed"
                className="testing-widget-iframe"
                allow="clipboard-write"
              />
            </div>
          </div>

          {/* Embed Info Section */}
          <div className="testing-embed-section">
            <div className="testing-section-header">
              <div className="testing-section-icon">💻</div>
              <h2>Want This On Your Website?</h2>
              <p>Add the LGBT Resources Widget or Map to your own website for free!</p>
            </div>
            <div className="testing-embed-cta">
              <a 
                href="https://lgbt-widget.vercel.app/widget" 
                target="_blank" 
                rel="noopener noreferrer"
                className="testing-cta-button"
              >
                Get Your Free API Key
              </a>
              <p className="testing-cta-note">
                Powered by <a href="https://www.lgbthotline.org/" target="_blank" rel="noopener noreferrer">LGBT National Help Center</a>
              </p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default Testing;